import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import {
  ReceiptVerificationStatus,
  receiptVerificationStatusToIcon,
  VerificationSummary,
} from 'src/models/receiptVerification.models'
import { css } from 'styled-components'

interface ReceiptsVerificationSummaryProps {
  summary: VerificationSummary
}

function summaryToLabel(summary: VerificationSummary): string | null {
  switch (summary) {
    case VerificationSummary.Verified:
      return 'All receipts verified'
    case VerificationSummary.Verifying:
      return 'Verifying receipts…'
    case VerificationSummary.NotVerified:
      return 'Not verified'
    case VerificationSummary.None:
    default:
      return null
  }
}

function summaryToIconStatus(
  summary: VerificationSummary,
): ReceiptVerificationStatus | undefined {
  switch (summary) {
    case VerificationSummary.Verified:
      return ReceiptVerificationStatus.Verified
    case VerificationSummary.Verifying:
      return ReceiptVerificationStatus.Verifying
    case VerificationSummary.NotVerified:
      return ReceiptVerificationStatus.Mismatched
    default:
      return undefined
  }
}

export default function ReceiptsVerificationSummary({
  summary,
}: ReceiptsVerificationSummaryProps): React.ReactElement | null {
  const translate = useTranslate()
  const label = summaryToLabel(summary)
  if (!label) return null

  const iconStatus = summaryToIconStatus(summary)

  return (
    <span
      data-testid="receipts-verification-summary"
      css={css`
        display: inline-flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
      `}
    >
      {iconStatus && receiptVerificationStatusToIcon(iconStatus)}
      <span>{translate(label)}</span>
    </span>
  )
}
